import Entity from '../entity'
import Tax from '../preferences/tax';
import MeasureUnit from '../catalogs/measureunit';
import Product from '../catalogs/product';

export default class PurchaseDetail extends Entity<number>{
    purchase_id: number;
    product_id : number;
    unity_id : number;
    tax_id : number;
    tax_rate: number;
    including_taxes: boolean;
    product_name: string;
    code: string;
    reference: string;
    quantity: number;
    exchange_rate: number;
    discount_type: string;
    cost: number;
    cost_wt: number;
    taxes: number;
    total: number;
    total_wt: number;
    product_cost: number;    
    product_price: number;
    stock: number;
    service: boolean;
    updated: boolean;
    quantity_received: number;
    discounts: number;
    
    prices: Array<any>;
    tax: Tax;
    unity: MeasureUnit;
    product: Product;
    unity_sym: string;
}


